import { LoggerService } from "@Front/Services/LoggerService/LoggerService";
import { waitForCookieAvailability } from "@Front/Stores/activeOfficeStoreCookieWait";
import { LECOFFRE_ACCESS_TOKEN_COOKIE_NAME } from "@Front/Utils/lecoffreSessionCookieHelpers";
import {
	replaceLocationOrReload,
	resolveFolderOfficeChangeRedirect,
} from "@Front/Stores/activeOfficeStoreFolderRedirect";
import { refreshJwtSessionAfterOfficeSwitch } from "@Front/Stores/activeOfficeStoreJwtRefresh";

import type { SetActiveOfficeApiSuccess } from "@Front/Stores/activeOfficeStoreSetActiveOfficeApi";

type StoreSlice = {
	activeOffice: { office?: { name?: string }; office_uid?: string } | null;
	availableOffices: Array<{ office_uid?: string; uid?: string; office?: { name?: string } }>;
	setActiveOfficeOptions: { redirectTo?: string; currentOfficeUidBeforeGuest?: string } | null;
	syncActiveOfficeFromContext(activeOfficeUid: string | null): void;
};

function resolveOfficeNameAfterSwitch(store: StoreSlice, finalOfficeUid: string): string | null {
	const match = store.availableOffices.find(
		(affiliation) => affiliation.office_uid === finalOfficeUid || affiliation.uid === finalOfficeUid,
	);
	return match?.office?.name ?? null;
}

export async function finalizeOfficeSwitchAfterApi(
	store: StoreSlice,
	userUid: string,
	officeUid: string,
	result: SetActiveOfficeApiSuccess,
): Promise<void> {
	await refreshJwtSessionAfterOfficeSwitch(result);

	const finalOfficeUid = result.office_uid || officeUid;
	store.syncActiveOfficeFromContext(finalOfficeUid);
	const switchedOfficeName = resolveOfficeNameAfterSwitch(store, finalOfficeUid);
	LoggerService.info("✅ Changement d'office terminé pour l'utilisateur courant, redirection", {
		userUid,
		officeUidCible: officeUid,
		finalOfficeUid,
		switchedOfficeName,
	});

	try {
		await waitForCookieAvailability(LECOFFRE_ACCESS_TOKEN_COOKIE_NAME, 200, 10);
		LoggerService.info("✅ Cookie accessToken vérifié avant reload");
	} catch (error) {
		const errorMsg = "Le cookie accessToken n'est plus disponible avant le rechargement de la page.";
		LoggerService.error(`❌ ${errorMsg}`, { error });
		throw new Error(errorMsg);
	}

	const explicitRedirect = store.setActiveOfficeOptions?.redirectTo ?? null;
	const redirectTo = explicitRedirect ?? resolveFolderOfficeChangeRedirect();
	store.setActiveOfficeOptions = null;
	replaceLocationOrReload(redirectTo);
}
